export default "__VITE_ASSET__f2416add__"